// @flow
'use strict';

import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Well } from 'react-bootstrap';

import type { IPaginatedData } from 'lib/types';
import { useEffectOnce } from 'lib/viewUtils';

import Filtros from '../filtros';
import PaginationFooter from 'components/common/pagination_footer';
import Icone from 'components/common/icone';
import DataTable, { Column } from 'components/common/data_table';

import DataRowColor from './data_row_color';
import { MUNICIPIO_SERVICO } from '../formulario/formulario';

type Fornecedor = {
  id : string,
  conta? : string,
  nome? : string,
  cnpj? : string,
  inscricao? : string,
  municipio? : string,
  ativo? : bool,
  autor : ?string,
}

type ListaProps = {
  dados? : IPaginatedData<Fornecedor>,
  trocaPagina : (p : number) => void,
  carregaLista : (query : {}) => void,
  handleRowClick : () => void,
}

export function formataMunicipio(municipio? : string) {
  const mun = MUNICIPIO_SERVICO.find(m => m.value === municipio);
  return mun ? mun.label : '';
}

export function formataConta(conta? : Fornecedor) {
  return conta ? conta.nome : '';
}

export default function Lista({ carregaLista, dados, handleRowClick, trocaPagina } : ListaProps) {
  useEffectOnce(() => {
    carregaLista({});
  });

  const { items = null, page, total, pageSize } = dados || {};

  return (
      <div>
        <Well bsStyle="sm" className="clearfix">
          <div className="pull-right">
            <LinkContainer to="/app/ferramentas/prestadores/new">
              <Button type="button" bsStyle="primary">
                <Icone nome="layer-plus" estilo="far">Criar Prestador</Icone>
              </Button>
            </LinkContainer>
          </div>
        </Well>
        <Filtros/>

        <DataTable className="link-button" data={ items } onRowClick={ handleRowClick }
                   rowComponent={ DataRowColor } striped hover>
          <Column expr="conta" formatter={ formataConta }>Conta</Column>
          <Column expr="nome">Nome</Column>
          <Column expr="municipio" formatter={ formataMunicipio }>Município</Column>
        </DataTable>
        <PaginationFooter label="Fornecedores" page={ page } total={ total } pageSize={ pageSize }
                          onPageChange={ trocaPagina }/>
      </div>
  );
}
